// frontend/src/pages/JoinAsProfessional.js
// /for-professionals — public marketing page for beauty professionals,
// restyled to mirror the premium OGESTYLE landing (shares the fb- design
// system from ForBusinesses.css). Photos are /landing/*.jpg placeholders —
// swap for final provided photography.

import React from "react";
import { Link } from "react-router-dom";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";
import { FaCheckCircle, FaArrowRight, FaStore, FaHome } from "react-icons/fa";
import "./ForBusinesses.css";
import "./JoinAsProfessional.css";

const IMG = {
  hero: "/landing/pros-hero.jpg",
  business: "/landing/pros-work.jpg",
  brand: "/landing/freelancer-brand.jpg",
};

const trust = [
  "Work at a business or go independent",
  "No contract — cancel anytime",
  "Registration in under 30 minutes",
];

function JoinAsProfessional() {
  return (
    <>
      <CustomerHeader />
      <main className="fb-page">
        {/* Hero */}
        <section className="fb-hero jp-hero">
          <div className="fb-wrap fb-hero-grid">
            <div>
              <p className="fb-eyebrow">For beauty professionals</p>
              <h1 className="fb-display">Start or grow your beauty career</h1>
              <p className="fb-sub">
                Work with an established salon or build your own independent
                brand — OGESTYLE supports both paths, all in one place.
              </p>
              <div className="fb-ctas">
                <Link className="fb-btn fb-btn-primary" to="/shops">
                  Explore businesses
                </Link>
                <Link className="fb-link" to="/freelancer">
                  Go the freelancer path
                </Link>
              </div>
            </div>

            <div className="fb-hero-art">
              <span className="fb-blob" />
              <img
                className="fb-hero-img"
                src={IMG.hero}
                alt="A beauty professional at work"
              />
              <div className="fb-chip-card">
                <span className="fb-chip-ic"><FaHome /></span>
                <div>
                  <p className="fb-chip-title">Your work, your brand</p>
                  <p className="fb-chip-sub">Looks you can share &amp; book</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trust chips */}
        <section className="fb-wrap fb-trust" aria-label="Highlights">
          {trust.map((t) => (
            <span key={t}><FaCheckCircle /> {t}</span>
          ))}
        </section>

        {/* Two paths */}
        <section className="fb-sec fb-sec--white">
          <div className="fb-wrap">
            <div className="fb-sec-head fb-center">
              <p className="fb-eyebrow">Choose your path</p>
              <h2 className="fb-display">Two ways to work with OGESTYLE</h2>
            </div>

            <div className="jp-cards">
              <article className="jp-card jp-card--navy">
                <img src={IMG.business} alt="A salon team at work" />
                <div className="jp-card-body">
                  <span className="jp-card-ic"><FaStore /></span>
                  <h3>Work at a Business</h3>
                  <p>
                    Join existing salons and beauty businesses as a
                    professional. Business-led job posting and matching is
                    coming soon.
                  </p>
                  <Link className="jp-card-link light" to="/shops">
                    Explore businesses <FaArrowRight />
                  </Link>
                </div>
              </article>

              <article className="jp-card jp-card--cream">
                <img src={IMG.brand} alt="An independent beauty professional" />
                <div className="jp-card-body">
                  <span className="jp-card-ic"><FaHome /></span>
                  <h3>Start as a Freelancer</h3>
                  <p>
                    Build your own independent beauty business, set your
                    availability and attract clients directly.
                  </p>
                  <Link className="jp-card-link" to="/freelancer">
                    Learn the freelancer path <FaArrowRight />
                  </Link>
                </div>
              </article>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="fb-wrap fb-cta-wrap">
          <div className="fb-cta-band">
            <div>
              <h2 className="fb-display">Ready to get started?</h2>
              <p className="fb-cta-desc">
                Independent? Register in under 30 minutes — no contract.
              </p>
            </div>
            <div className="fb-cta-actions">
              <Link className="fb-btn fb-btn-primary" to="/freelancer-signup">
                Start as a freelancer
              </Link>
              <Link className="fb-btn fb-btn-outline" to="/shops">
                Explore businesses
              </Link>
            </div>
          </div>
        </section>
      </main>
      <CustomerFooter />
    </>
  );
}

export default JoinAsProfessional;
